<div class="toaster-container" *ngFor="let toast of toasts; let i = index">
    <div class="toast" [ngClass]="toast.type" (click)="removeToast(i)">
        <div>
            <p>{{ toast.message }}</p>
        </div>
        <div class="toast-close">
            <span>&times;</span>
        </div>
    </div>
</div>
